import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  Spinner,
  Text,
} from "@chakra-ui/react";

export const OverlayLoader = ({ isOpen, text = "Processing..." }) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {}}
      isCentered
      closeOnOverlayClick={false}
    >
      <ModalOverlay bg="blackAlpha.600" backdropFilter="blur(2px)" />
      <ModalContent bg="transparent" boxShadow="none" maxW="fit-content">
        <ModalBody
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          p={6}
          bg="white"
          borderRadius="lg"
          boxShadow="xl"
        >
          <Spinner
            thickness="4px"
            speed="0.65s"
            emptyColor="gray.200"
            color="blue.500"
            size="xl"
            mb={4}
          />
          <Text fontWeight="medium" color="gray.700">
            {text}
          </Text>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
